import {
  a174,
  a204,
  a718,
  a732,
  a736,
  a740,
  a745,
} from "Components/Api/RootApiPath";

export const fetchVendorTouncheList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a732, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch invoice list"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(`${"Failed to fetch vendor tounch list, try again later"}`);
  }
};

export const fetchVendorTounch = async ({ queryKey }) => {
  const [, id, clientCode] = queryKey;
  try {
    const data = await fetch(a736, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
        Id: id,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch vendor tounch"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(`${"Failed to fetch vendor tounch, try again later"}`);
  }
};

export const fetchCustomerTouncheList = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a740, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch customer tounch list"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(
      `${"Failed to fetch customer tounch list, try again later"}`
    );
  }
};

export const fetchCustomerTounch = async ({ queryKey }) => {
  const [, id, clientCode] = queryKey;
  try {
    const data = await fetch(a745, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
        Id: id,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch customer tounch"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(`${"Failed to fetch customer tounch, try again later"}`);
  }
};
